module.exports = __webpack_public_path__ + "teqbahn-assets/media/28.c63ec71c.jpg";